<template>
  <div>
    <h3>{{ searchHeader }}</h3>
    <div class="search-container">
      <div class="search-input">
        <input
          autofocus
          class="k-textbox"
          v-model="query"
          :placeholder="searchPlaceholder"
          @change="searchSubmit"
        />
        <button class="k-button k-primary" href="#" @click="searchSubmit">
          <span class="icon icon-search"></span>
        </button>
      </div>
      <div class="radio-buttons">
        <input
          type="radio"
          class="k-radio"
          id="active"
          :value="true"
          v-model="isActive"
          @change="searchSubmit"
        />
        <label class="k-radio-label" for="active">Active</label>
        <input
          type="radio"
          class="k-radio"
          id="archive"
          :value="false"
          v-model="isActive"
          @change="searchSubmit"
        />
        <label class="k-radio-label" for="archive">Archived</label>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '../../../event-bus';
import Constants from '../../constants/constants';

export default {
  name: 'GridSearch',
  data() {
    return {
      isActive: true,
      query: ''
    };
  },
  methods: {
    searchSubmit() {
      this.$emit(Constants.EventBus.searchSubmit, this.query, this.isActive);
    }
  },
  props: {
    searchHeader: {
      type: String,
      required: true
    },
    searchPlaceholder: {
      type: String,
      required: true
    }
  },
  created() {
    EventBus.$on(Constants.EventBus.globalClearSearch, () => {
      this.query = '';
      this.$emit(Constants.EventBus.searchSubmit, this.query, this.isActive);
    });
  }
};
</script>

<style lang="scss" scoped>
.search-container {
  align-items: center;
  display: flex;
  padding: 10px 0;

  .search-input {
    display: inline-flex;

    span {
      font-size: 18px;
    }

    .k-textbox {
      margin-top: 0;
      width: 200px;
    }
  }

  .radio-buttons {
    display: inline-flex;
    margin-left: 20px;

    label {
      margin-right: 20px;
    }
  }
}
</style>
